export enum Environments {

    DEV = 'DEV',
    NPE = 'NPE',
    PRD = 'PRD'

};